import { useMemo } from 'react';
import { useCurrentSite } from '@hotjar/site';
import { integrationStep } from '@hotjar/webapp/tracking/common';
import { extractSiteGroupingProps } from '@hotjar/webapp/tracking/utils';

interface GTMIntegrationTracking {
  trackIntegrationStep: (step: string) => void;
}

export const useGTMIntegrationTracking = (): GTMIntegrationTracking => {
  const { data: site } = useCurrentSite();
  const groupData = useMemo(() => site?.id && extractSiteGroupingProps(site), [site]);

  return useMemo(
    () => ({
      trackIntegrationStep: (stepName: string) =>
        groupData &&
        integrationStep({
          name: 'Google Tag Manager',
          type: 'Script installation',
          step: stepName,
          groupData,
          data: {},
        }),
    }),
    [groupData],
  );
};
